import { render, staticRenderFns } from "./commonPhrases.vue?vue&type=template&id=62eabbe6"
import script from "./commonPhrases.vue?vue&type=script&lang=js"
export * from "./commonPhrases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports